import React, { Component, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import Iframe from "react-iframe";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Input from "@material-ui/core/Input";
import Button from "@material-ui/core/Button";
import { withRouter } from "react-router-dom";
import InputLabel from "@material-ui/core/InputLabel";
import CardActions from "@material-ui/core/CardActions";
import ChatBoxMoreInfo from "./ChatBoxMoreInfo";
import PropTypes from "prop-types";
import axios from 'axios';

const styles = {
  root: {
    width: "100vw",
    // minWidth: '150px',
    // height: '500px',
    // minHeight: '350px',
    align: "center",
    //overflowX: 'auto',
    //display: 'column',
    alignItem: "center",
    // margin: '0 Auto',
  },
  formControl: {
    // margin: theme.spacing.unit * 3,
  },
  group: {},
  radio: {
    "&$checked": {
      color: "#B71C1C",
    },
  },
  checked: {},
  progress: {
    /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
    flexDirection: "column",
    // margin: theme.spacing.unit * 3,
  },
  button: {
    display: "flex",
    justifyContent: "center",
    // margin: '0 Auto',
  },
  InputLabel: {
    fontSize: "14px",
  },
  rightInput: {
    marginLeft: "50px",
  },
  country: {
    marginTop: "15px",
    marginBottom: "10px",
  },
  hkidPassport: {
    marginTop: "15px",
    marginBottom: "10px",
  },
};

class EmailReadStatus extends Component {
  state = {
    Rcreated: false,
    Ccreated: false,
    RDcreated: false,
    CDcreated: false,
  };

  handleChangeDeliveryStatus = (userType) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/createEmailSentPDF`
    if (userType == 'claimant'){
      this.setState({
        CDcreated: false
      })
    }
    else{
      this.setState({
        RDcreated: false
      })
    }
    const data = {
      caseId: parseInt(this.props.caseData.caseId),
      userType: userType
    }
    axios.post(url, {
      ...data
    })
    .then((response) => {
      console.log('created ##')
      if (userType == 'claimant'){
        this.setState({
          CDcreated: true
        })
      }
      else{
        this.setState({
          RDcreated: true
        })
      }

    })
  }

  handleChangeReadReceipt = (userType) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/createReadReceiptPDF`
    if (userType == 'claimant'){
      this.setState({
        Ccreated: false
      })
    }
    else{
      this.setState({
        Rcreated: false
      })
    }
    const data = {
      caseId: parseInt(this.props.caseData.caseId),
      userType: userType
    }
    axios.post(url, {
      ...data
    })
    .then((response) => {
      console.log('created ##')
      if (userType == 'claimant'){
        this.setState({
          Ccreated: true
        })
      }
      else{
        this.setState({
          Rcreated: true
        })
      }
      

    })
  }

  render() {
    const { classes } = this.props;

    return (
      <div style={{ marginLeft:'15px' }}>
        <br></br>
        <b style={{marginLeft:'15px'}}>{this.context.t("Claimant's Email Status")}</b><br></br>
        <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={this.props.submitInProgress}
            className={classes.bInput}
            onClick={()=> {this.handleChangeReadReceipt('claimant')}}
            style={{
              fontSize: "14px",
              marginBottom: "15px",
              textTransform: 'capitalize',
              marginLeft:'15px'
            }}
          >{this.context.t("Download Read Record")}</Button>&nbsp;&nbsp;&nbsp;
          { this.state.Ccreated && <a style={{color:'red'}} target="_blank" href={`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.caseData.conversationId}_claimantEmailReadReceipts`}>{this.context.t("Download PDF")}</a>}<br></br>

          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={this.props.submitInProgress}
            className={classes.bInput}
            onClick={()=> {this.handleChangeDeliveryStatus('claimant')}}
            style={{
              fontSize: "14px",
              marginBottom: "15px",
              textTransform: 'capitalize',
              marginLeft:'15px'
            }}
          >{this.context.t("Download Sent Record")}</Button>&nbsp;&nbsp;&nbsp;
          { this.state.CDcreated && <a style={{color:'red'}} target="_blank" href={`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.caseData.conversationId}_claimantemailSent`}>{this.context.t("Download PDF")}</a>}<br></br>
          <b style={{marginLeft:'15px'}}>{this.context.t("Respondent's Email Status")}</b><br></br>

          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={this.props.submitInProgress}
            className={classes.bInput}
            onClick={()=> {this.handleChangeReadReceipt('respondent')}}
            style={{
              fontSize: "14px",
              marginBottom: "15px",
              textTransform: 'capitalize',
              marginLeft:'15px'
            }}
          >{this.context.t("Download Read Record")}</Button>&nbsp;&nbsp;&nbsp;
          { this.state.Rcreated && <a style={{color:'red'}} target="_blank" href={`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.caseData.conversationId}_respondentEmailReadReceipts`}>{this.context.t("Download PDF")}</a>}<br></br>

          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={this.props.submitInProgress}
            className={classes.bInput}
            onClick={()=> {this.handleChangeDeliveryStatus('respondent')}}
            style={{
              fontSize: "14px",
              marginBottom: "15px",
              textTransform: 'capitalize',
              marginLeft:'15px'
            }}
          >{this.context.t("Download Sent Record")}</Button>&nbsp;&nbsp;&nbsp;
          { this.state.RDcreated && <a style={{color:'red'}} target="_blank" href={`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.caseData.conversationId}_respondentemailSent`}>{this.context.t("Download PDF")}</a>}
      </div>
    );
  }
}

// export default withStyles(styles)(ArbitratorAcceptRejectBox);
const mapStateToProps = (state) => {
  return {
    caseId: state.caseInfo.caseId,
    caseData: state.caseInfo.caseData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AdminAcceptReject: (caseId, status) =>
      dispatch(actions.AdminAcceptReject(caseId, status)),
  };
};

EmailReadStatus.contextTypes = {
  t: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(EmailReadStatus)));
